import { render, staticRenderFns } from "./EditVideo.vue?vue&type=template&id=6f13f99e&scoped=true&"
import script from "./EditVideo.vue?vue&type=script&lang=js&"
export * from "./EditVideo.vue?vue&type=script&lang=js&"
import style0 from "./EditVideo.vue?vue&type=style&index=0&id=6f13f99e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f13f99e",
  null
  
)

export default component.exports